export const LISTING_LEASING = {
  title: 'Listing & Leasing',
  id: 'listing-leasing',
  content: [
    {
      header: 'Marketing',
      description:
        'List the property on all 3rd party websites such as Zillow, Hotpads, Craiglist etc',
      belong: true,
      traditional_property_management: true,
      tech_property_management: true,
    },
    {
      header: 'Resident Qualification',
      description:
        'Find residents for your home and vet them with a background and credit check',
      belong: true,
      traditional_property_management: true,
      tech_property_management: true,
    },
    {
      header: 'Communications',
      description: 'Handle all resident communications and lease management',
      belong: true,
      traditional_property_management: true,
      tech_property_management: true,
    },
    {
      header: 'Tours',
      description:
        'Conduct in-person, virtual, and self-managed tours for prospective residents at no extra cost',
      belong: true,
      traditional_property_management: false,
      tech_property_management: false,
    },
    {
      header: 'Pricing',
      description:
        'Real-time market data for rental pricing to minimize vacancy and maximize long-term returns',
      belong: true,
      traditional_property_management: false,
      tech_property_management: false,
    },
  ],
};
export const ONOGING_PROPERTY_MANAGEMENT = {
  title: 'Ongoing Property Management',
  id: 'property-management',
  content: [
    {
      header: 'Local Support',
      description:
        'Local, boots-on–the-gound concierge-level support from a human, not just an option to log maintenance emergencies',
      belong: true,
      traditional_property_management: true,
      tech_property_management: false,
    },
    {
      header: 'Rent Collection',
      description: 'Collect rent from residents',
      belong: true,
      traditional_property_management: true,
      tech_property_management: true,
    },
    {
      header: 'Support',
      description:
        'Ensure maintenance emergencies are handled in a safe, timely fashion',
      belong: true,
      traditional_property_management: true,
      tech_property_management: true,
    },
    {
      header: 'Maintenance',
      description:
        'Certified in-house maintenance professionals to provide high quality, timely, and cost effective, repairs and renovations',
      belong: true,
      traditional_property_management: false,
      tech_property_management: false,
    },
    {
      header: 'Eviction Protection',
      description:
        'Protection against evictions with up to 3 months of rent in coverage against legal fees',
      belong: true,
      traditional_property_management: false,
      tech_property_management: false,
    },
    {
      header: 'Convenience',
      description:
        'A mobile app for homeowners to manage their entire renting experience from anywhere',
      belong: true,
      traditional_property_management: false,
      tech_property_management: true,
    },
    {
      header: 'Maintenance',
      description:
        'Recurring services like cleaning and landscaping, easily managed from your phone anytime',
      belong: true,
      traditional_property_management: false,
      tech_property_management: false,
    },
  ],
};
export const CASHFLOW_FINANCIAL_TOOLS = {
  title: 'Cash Flow and Financial Tools',
  id: 'cash-flow',
  content: [
    {
      header: 'Fees',
      description:
        'Transparent, inclusive fees, with no sneaky extras like setup costs and lease renewal charges',
      belong: true,
      traditional_property_management: false,
      tech_property_management: false,
    },
    {
      header: 'Guarantees',
      description:
        'Guaranteed rent paid to homeowners on time, even if resident payments are late',
      belong: true,
      traditional_property_management: false,
      tech_property_management: true,
    },
    {
      header: 'Cash Flow Solutions',
      description:
        'Financial solutions for managing cash-flow on your terms, including options to split the cost of major repairs across a lease period so you’re always cash-flow-positive',
      belong: true,
      traditional_property_management: false,
      tech_property_management: false,
    },
    {
      header: 'Home Selling',
      description:
        'The option to apply any management fees paid as a discount towards brokerage fees if you choose to sell the home',
      belong: true,
      traditional_property_management: false,
      tech_property_management: false,
    },
    {
      header: 'Terms',
      description: 'No contract or termination fee',
      belong: true,
      traditional_property_management: false,
      tech_property_management: false,
    },
  ],
};
